import React, { useState } from 'react'
import Select from 'react-select'
import { Dropdown, Menu } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'

import Receive from '../../components/reusable/receive'

import { stringifyDate, useListData, usePet, useToggle } from '../../modules'

import NewIncome from '../../components/drawers/newIncome'

import { accountTypes } from '../../data'
import SelectLabel from '../../components/reusable/selectLabel'

const Income = ({ namespace }) => {
    const [selected, setSelected] = useState()
    const [string, setString] = useState('')
    const [accType, setAccType] = useState()

    const [newIncomeDrawer, toggleNewIncomeDrawer] = useToggle()
    const [incomeDrawer, toggleIncomeDrawer] = useToggle()

    const select = comp => {
        setSelected(comp)
        toggleIncomeDrawer()
    }
    
    const [
        { loading, error, fetch }, 
        { list: income = [] }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('ledgerEntries', {
        type: 'Income',
        string,
        accountType: accType?.value,
    }, { notify: true, manual: false }, 'entries')

    const refresh = () => {
        navigate(1)
        fetch()
    }

    const search = str => {
        setString(str)
    }
    
    const onComplete = ({ data }, notif, ops) => {
        notif(`Income has been ${selected?.active ? 'deactivated' : 'activated' }`, ops('success'))        
        refresh()
    }

    const [, execute] = usePet('toggleActive', { id: selected?._id }, { notify: true, callback: onComplete, manual: true })

    const toggleActive = ins => {
        setSelected(ins)
        execute()        
    }

    const changeIncome = acc => {
        setAccType(acc)
        refresh()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full mx-auto">
            <NewIncome
                onPerform={ refresh }
                toggle={ toggleNewIncomeDrawer }
                visible={ newIncomeDrawer } />            
            {/* {
                roleDrawer &&
                <EditRole
                    onPerform={ fetch }
                    role={ selected }
                    toggle={ toggleRoleDrawer }
                    visible={ roleDrawer } />
            } */}
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Search by Name" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <button onClick={ toggleNewIncomeDrawer } className="btn hisani-btn-green-light text-white">
                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                        </svg>
                        <span className="hidden xs:block ml-2">Add New Income</span>
                    </button>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Income</h2>
                    <Select
                        isClearable
                        value={accType}
                        className="mb-3"
                        options={ accountTypes }
                        onChange={ changeIncome }
                        formatGroupLabel={ SelectLabel }
                        placeholder="Search for Income type"
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }} />
                </header>
                <div className="p-3">

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                income?.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Account Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Amount</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Subject</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {/* Row */}
                                            {
                                                income?.map((inc, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ inc?.account?.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">Ksh. { inc.amount }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ inc?.subjectName }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ stringifyDate(inc.committedOn) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Menu.Item onClick={ () => select(inc) }>View</Menu.Item>
                                                                        <Menu.Item onClick={ () => toggleActive(inc) }>{ inc.active ? 'Deactivate' : 'Activate' }</Menu.Item>
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="w-full h-16 flex items-center justify-center">
                                        <p className="font-semibold text-base">Please click above to add a new income</p>
                                    </div>
                            }
                        </Receive>
                        {Paginate}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Income
